// src/app/core/interceptors/error.interceptor.ts
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

export const SKIP_GLOBAL_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_GLOBAL_ERROR_HANDLER)) {
    return next(req);
  }

  const errorHandler = inject(ErrorHandlerService);

  return next(req).pipe(
    catchError((error) => {
      errorHandler.handleError(error);
      throw error;
    }),
  );
};
